/**
 * c-tracking.js — アフィリエイトリンクのクリックを GA4 に送る
 *
 * なぜ必要か（設計書 §5）:
 *   購入は外部サイト（Amazon / ブランドEC）で起きるので、GA4 だけでは「売れたか」は分からない。
 *   分かるのは「どの記事の、どの商品リンクが、どの ASP 経由で押されたか」まで。
 *   売上との突き合わせは ASP 側の sub ID レポートで行う（sub ID には記事 handle が載っている）。
 *
 * 送信イベント: affiliate_click
 *   - affiliate_program : amazon-us / awin / rakuten-advertising / direct
 *   - product_handle    : affiliate_product metaobject の handle
 *   - article_handle    : 記事の handle（sub ID と同じ値）
 *   - link_url          : 遷移先
 *
 * 実装方針:
 *   カードは記事本文の途中に動的に差し込まれるため、個別要素ではなく document で
 *   イベント委譲する（後から DOM が増えても拾える）。
 */
(function () {
  'use strict';

  var CARD_SELECTOR = '.c-product-card';

  function sendEvent(card, linkEl) {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'affiliate_click', {
      affiliate_program: card.getAttribute('data-program') || 'unknown',
      product_handle: card.getAttribute('data-product-handle') || 'unknown',
      article_handle: card.getAttribute('data-article-handle') || 'unknown',
      link_url: linkEl.href || '',
    });
  }

  function onClick(event) {
    var link = event.target.closest('a[rel*="sponsored"]');
    if (!link) return;

    var card = link.closest(CARD_SELECTOR);
    if (!card) return;

    sendEvent(card, link);
  }

  // click だけだと中クリック（新しいタブで開く）を取りこぼすので auxclick も拾う
  document.addEventListener('click', onClick);
  document.addEventListener('auxclick', function (event) {
    if (event.button === 1) onClick(event);
  });
})();
